module.exports = __webpack_public_path__ + "static/media/logo.e029e7be.png";